import { ECOMMERCES } from '@app/services/shops/shop.model';
import { masterCarrierTypeNames } from '@pdqdev/pdq-shared/dist/CarrierData';
import { Carrier } from '@app/services/carriers/carrier.model';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';

export function filterUsableCarriers(carriers: Carrier[], shop: Shop, shopMetadata: any) {
  const shopPlatform: ECOMMERCES = shop?.platform as ECOMMERCES;

  if (!carriers?.length) {
    return carriers;
  }
  if (shopPlatform && shopPlatform !== ECOMMERCES.SHOPIFY && !shopMetadata.isMasterCarrierAccountsEnabled) {
    carriers = carriers.filter((carrier) => {
      const carrierTypeName = carrier.type.name;
      return !masterCarrierTypeNames?.includes(carrierTypeName);
    });
  }

  return carriers;
}
